import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpLoaderService } from './core/services/http-loader.service';
import { UploadInterruptionService } from './shared/services/upload-interruption.service';
import { SnackBarService } from './shared/services/snackbar.service';
import { LabelService } from './shared/services/label.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'enclaveApp';

  readonly isGlobalLoading$: Observable<boolean>;

  constructor(
    private readonly httpLoaderService: HttpLoaderService,
    private readonly uploadInterruption: UploadInterruptionService,
    private readonly snackBarService: SnackBarService,
    private readonly labelService: LabelService
  ) {
    this.isGlobalLoading$ = this.httpLoaderService.loading$;
  }

  ngOnInit(): void {
    this.uploadInterruption.registerBeforeUnloadListener();
    if (this.uploadInterruption.consumeInterruptionIfAny()) {
      this.snackBarService.displaySnackBar(this.labelService.labels.TOAST.UPLOAD_INTERRUPTED, 'warning', 10000);
    }
  }
}
